import { SortableFilter }          from './../common/sortable-filter';

export class PeakSortableFilter extends SortableFilter {
    public year: number;
    public month: number;
    public trainUid: string;
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/peak-list/peak-sortable-filter.ts